<!-- <div> -->
<mat-label class="mb-2 text-sm">
  {{ label | translate }}
  <small class="text-gray-400"
    >({{ (required ? 'shared:required' : 'shared:optional') | translate }})
    {{ required ? '*' : '' }}</small
  >
</mat-label>

<treo-message
  *ngIf="infoDialog"
  class="mt-2 mb-2"
  [appearance]="'outline'"
  [showIcon]="true"
  [showButtonClose]="false"
  [type]="'info'"
  [@shake]="true">
  <div>
    {{ infoDialog }}
  </div>
</treo-message>

<div
  class="flex flex-col flex-auto mt-0 animate__animated animate__fadeIn"
  [style.height.px]="74"
  *ngIf="!file">
  <div class="h-full hover:shadow-lg flex rounded-lg cursor-pointer">
    <div
      class="relative hover:shadow-sm w-full flex items-center justify-center rounded-lg border-2 border-dashed border-gray-200 text-sm font-medium py-4">
      <input
        class="opacity-0 absolute w-full h-full cursor-pointer"
        [id]="'images'"
        [accept]="
          'image/jpeg,image/png,image/webp,image/svg+xml,application/pdf'
        "
        [required]="required"
        (change)="send($event)"
        type="file" />
      <mat-icon class="icon-size-17 fa-regular fa-upload"></mat-icon>
      <div *ngIf="buttonTextUpload" class="text-sm text-gray-500 font-light">
        {{ buttonTextUpload }}
      </div>
    </div>
  </div>
</div>

<div
  class="lex flex-col flex-auto m-0 animate__animated animate__fadeIn"
  *ngIf="!!file">
  <li class="flex flex-row mb-1">
    <div
      class="w-full group select-none bg-gray-100 hover:bg-parrot-50 border hover:border-primary-500 rounded-md flex flex-1 items-center p-4 hover:shadow-sm"
      [ngClass]="{
        'border-green-500': !error,
        'border-red-500': error
      }">
      <div
        class="flex flex-col rounded-md w-10 h-10 bg-gray-200 justify-center items-center lg:mr-4 md:mr-4 sm:mr-4 xs:mr-2">
        <a [href]="file.url" target="_blank" rel="noopener">
          <img
            [src]="file.url"
            alt=""
            *ngIf="file.mimeType.includes('image')" />
        </a>
        <mat-icon
          class="fa-regular fa-file-pdf"
          *ngIf="file.mimeType.includes('pdf')"></mat-icon>
      </div>
      <div class="flex-1 pl-1">
        <div class="text-black text-sm ml-2">
          {{ file.name | slice : 0 : 20 }}
        </div>
        <div class="text-gray-600 text-sm ml-2">
          {{
            file.size
              ? (file.size / 1024 / 1024 | number : '1.0-2') + ' MB '
              : ''
          }}
        </div>
      </div>
      <button mat-icon-button (click)="delete()">
        <mat-icon class="icon-size-17 fa-regular fa-trash-can"></mat-icon>
      </button>
    </div>
  </li>
</div>

<small class="block" *ngIf="acceptedTypes || maxSize">
  <span *ngIf="maxSize"
    >{{ 'shared:fileValidationSizeMessage' | translate }}
    <span class="text-gray-400">{{ formatFileSize(maxSize) }}.</span></span
  >
  <span *ngIf="acceptedTypes">
    {{ 'shared:fileValidationTypeMessage' | translate }}
    <span class="text-gray-400">{{ getAcceptedFileTypes() }}.</span>
  </span>
</small>

<mat-error *ngIf="error" class="text-red-600 text-xs">{{
  error | translate
}}</mat-error>
